import { FC } from "react";

interface NotFoundPageIconSVGProps {
    className?: string;
}

const NotFoundPageIconSVG: FC<NotFoundPageIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="551"
            height="411"
            viewBox="0 0 551 411"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M479.8 367V323.95H375.25V298.6L450.55 157H484.75L410.5 295.9H479.8V249.25H508.75V295.9H541.15V323.95H508.75V367H479.8Z"
                fill="#F1F1F1"
            />
            <path
                d="M109.8 367V323.95H5.25V298.6L80.55 157H114.75L40.5 295.9H109.8V249.25H138.75V295.9H171.15V323.95H138.75V367H109.8Z"
                fill="#F1F1F1"
            />
            <path
                d="M266.579 206.818L133.174 171.135L118.965 204.082L131.566 210.152L108.358 260.212L45.8242 243.779L64.959 194.156L75.1916 196.333L82.4853 174.165L72.9158 170.826L106.543 79.7134C124.448 54.5902 174.3 6.54956 230.465 15.372C216.255 29.5516 186.128 62.2399 179.308 79.5559C172.488 96.8719 161.562 121.829 156.952 132.143L270.839 163.152M347.678 171.942L373.26 182.077M292.445 217.795L340.863 264.328L351.383 295.499L461.485 402.856L513.308 356.277L406.806 253.335L375.728 239.425L319.255 181.534"
                stroke="#0948A6"
                strokeWidth="15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M257.172 200.665L123.768 164.983L109.558 197.93L122.16 204L98.9513 254.06L36.418 237.627L55.5527 188.003L65.7854 190.18L73.0791 168.013L63.5095 164.673L97.1371 73.561C115.042 48.4379 164.893 0.397218 221.059 9.21962C206.849 23.3992 176.722 56.0875 169.902 73.4036C163.081 90.7196 152.156 115.677 147.546 125.991L261.432 157M338.272 165.789L363.854 175.924M283.039 211.642L331.457 258.175L341.976 289.346L452.079 396.704L503.901 350.125L397.399 247.183L366.322 233.272L309.849 175.381"
                stroke="url(#paint0_linear_196_10024)"
                strokeWidth="15"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M273.85 371.5C260.45 371.5 248.4 368.65 237.7 362.95C227.1 357.25 218.05 349.35 210.55 339.25C203.15 329.15 197.5 317.5 193.6 304.3C189.7 291.1 187.75 277 187.75 262C187.75 246.9 189.7 232.75 193.6 219.55C197.5 206.35 203.15 194.75 210.55 184.75C218.05 174.65 227.1 166.75 237.7 161.05C248.4 155.35 260.45 152.5 273.85 152.5C287.25 152.5 299.25 155.35 309.85 161.05C320.55 166.75 329.6 174.65 337 184.75C344.5 194.75 350.2 206.35 354.1 219.55C358.1 232.75 360.1 246.9 360.1 262C360.1 277 358.1 291.1 354.1 304.3C350.2 317.5 344.5 329.15 337 339.25C329.6 349.35 320.55 357.25 309.85 362.95C299.25 368.65 287.25 371.5 273.85 371.5ZM273.85 341.8C281.85 341.8 289.1 340 295.6 336.4C302.1 332.7 307.7 327.4 312.4 320.5C317.2 313.6 320.85 305.25 323.35 295.45C325.85 285.55 327.1 274.4 327.1 262C327.1 245.4 324.85 231.15 320.35 219.25C315.95 207.25 309.75 198.1 301.75 191.8C293.85 185.4 284.55 182.2 273.85 182.2C265.95 182.2 258.7 184.05 252.1 187.75C245.6 191.35 240 196.6 235.3 203.5C230.6 210.4 226.95 218.75 224.35 228.55C221.85 238.35 220.6 249.5 220.6 262C220.6 278.6 222.8 292.85 227.2 304.75C231.7 316.65 237.95 325.8 245.95 332.2C253.95 338.6 263.25 341.8 273.85 341.8Z"
                fill="#F1F1F1"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_196_10024"
                    x1="64.9209"
                    y1="120.811"
                    x2="489.819"
                    y2="383.966"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2283DD" />
                    <stop offset="1" stopColor="#0F6ABE" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default NotFoundPageIconSVG;
